export default "__VITE_ASSET__1d8e6a96__"